import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useSetInterval } from "../../hooks/useSetInterval";

import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Skeleton from "@mui/material/Skeleton";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import TableRowNoResults from "../../components/TableRowNoResults";
import {
  StripedTableRow,
  StripedTableCell,
} from "../../components/StripedTable";
import { getUserByBarcode } from "../../services/UserService";
import IconLoader from "../../components/IconLoader";

import isEmpty from "lodash-es/isEmpty";
import { doService } from "../../services/ServiceHelper";
import { showError, showSuccess, showToast } from "../../components/ATPDialogs";
import { hasError, getError } from "../../services/ServiceHelper";
import { getActivityDateStudents } from "../../services/ActivityService";
import { getPeriodName } from "../../services/SchoolService";
import { doAttendByTeacher } from "../../services/ActivityService";

import dayjs from "dayjs";

const ActivityKiosk = () => {
  const { activityDateEid } = useParams();

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_showProgress, setShowProgress] = useState(false);

  const [pageFocused, setPageFocused] = useState(document.hasFocus());

  const [_isLoaded, setIsLoaded] = useState(false);
  const [_activityDetails, setActivityDetails] = useState({});
  const [_presentStudents, setPresentStudents] = useState([]);
  const [_studentId, setStudentId] = useState("");
  const [_allCount, setAllCount] = useState(0);

  let _capturedCode = "";

  useEffect(() => {
    initActivityDateStudents();
    return initScanner();
  }, []);

  const initScanner = () => {
    const handleKeyDown = (event) => {
      // bail on error
      if (event.key == null) {
        return;
      }

      if (event.key === "Enter") {
        console.log("ENTER");
        console.log(_capturedCode);
        doExamineCode(_capturedCode);
        // process and reset
        _capturedCode = "";
        return;
      }

      // ignore modifier keys, only handle real characters
      if (event.key.length === 1) {
        const code = _capturedCode;
        _capturedCode += event.key;
      }

      // handle Backspace
      if (event.key === "Backspace") {
        console.log("Backspace");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    const handleFocus = () => setPageFocused(true);
    const handleBlur = () => setPageFocused(false);

    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  };

  const initActivityDateStudents = () => {
    setShowProgress(true);
    getActivityDateStudents(_school, _jwt, activityDateEid)
      .then((results) => {
        setShowProgress(false);
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to get Activity Date Students: ",
            getError(results)
          );
          return;
        }

        // attach a few extra attributes for each student
        for (let student of results.data.attendees) {
          student.pointChecked = false;
          student.hourNum = 0;
          student.minuteNum = 0;
          student.isFutureChecked = true;
        }

        const presentStudents = [];
        for (const attendee of results.data.attendees) {
          if (
            attendee.is_school_absent === false &&
            (attendee.is_late === true || attendee.is_present === true)
          ) {
            presentStudents.push(attendee);
          }
        }
        setAllCount(results.data.attendees.length);

        setPresentStudents(presentStudents);
        setActivityDetails(results.data);
        setIsLoaded(true);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const isSomethingFocused = () => {
    return document.hasFocus();
  };

  const doExamineCode = (capturedCode) => {
    if (capturedCode.length === 0) {
      return;
    }

    if (capturedCode.length < 5) {
      return;
    }

    setShowProgress(true);
    doService(getUserByBarcode(_school, _jwt, capturedCode), (result) => {
      setShowProgress(false);

      if (result.data == null) {
        showError(
          "Unable to Add Attendance",
          "Code does not exist for student."
        );
        return;
      }

      addStudents([result.data.eid]);
    });

    // console.log("CODE: " + capturedCode);
  };

  const addStudents = (studentEids) => {
    if (studentEids.length === 0) {
      return;
    }
    if (studentEids.length > 1) {
      showError("Unable to Add Students", "Please only add one student at a time.");
      return;
    }

    setShowProgress(true);
    doAttendByTeacher(_school, _jwt, studentEids[0], activityDateEid)
      .then((results) => {
        if (hasError(results) === true) {
          showError("Unable to Update Student", getError(results));
          return;
        }

        showSuccess("Student Marked as Present.");
        setStudentId("");
        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  // run every 15s
  useSetInterval(() => {
    // initOpenPasses();
  }, 15000);

  useSetInterval(() => {
    // const passes = clone(_openPasses);
    // calcTimeRemain(passes);
    // setOpenPasses(passes);
  }, 5000);

  const onClickPresent = () => {
    if (isEmpty(_studentId)) {
      showError("Please enter Student ID.");
      return;
    }
    doExamineCode(_studentId);
  };

  return (
    <>
      <DrawerAppBar
        disableLogout={true}
        showLogout={false}
        showHamburger={false}
      />

      <Container sx={{ mt: 1 }}>
        <Title text="Activity Kiosk" showBack={false} />

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={11}>
            <Alert severity="info">
              This page allows students to use a barcode scanner to scan their
              ID badge to mark them as present. It also permits the student to
              add their ID manually.
              <br />
              This page must be the top page and clicked upon for a scanner to
              receiver the barcode content. The bar below under Open Passes will
              be green to indicate that you can scan the barcode. If it is red,
              then click anywhere on this page until it is green.
            </Alert>
          </Grid>
          <Grid item xs={1}>
            <IconLoader iconName="scanner" progress={_showProgress} />
          </Grid>
        </Grid>

        {pageFocused === true && (
          <Alert severity="success">
            You Can Scan Barcodes Now (page is focused)
          </Alert>
        )}
        {pageFocused === false && (
          <Alert severity="error">
            Page needs to be Clicked to scan barcodes.
          </Alert>
        )}

        {_isLoaded === false && (
          <>
            <Skeleton />
            <Skeleton />
          </>
        )}
        {_isLoaded === true && (
          <h3>
            {_activityDetails.name} on{" "}
            {dayjs(_activityDetails.date).format("MM/DD")} -{" "}
            {getPeriodName(_school, _activityDetails.period - 1)}
          </h3>
        )}

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            Enter Student ID
          </AccordionSummary>
          <AccordionDetails>
            <InputLabel sx={{ mt: 1 }}>* Student ID</InputLabel>
            <Box display="flex" gap={1}>
              <TextField
                margin="dense"
                type="text"
                fullWidth
                size="small"
                onChange={(evt) => setStudentId(evt.target.value)}
                value={_studentId}
                sx={{ mt: 0 }}
              />
              <Button variant="contained" onClick={onClickPresent}>
                Submit
              </Button>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            <Grid container>
              <Grid item xs={10}>
                Students Marked as Present
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "right", color: "#565c65" }}>
                Present/Total: {_presentStudents.length}/{_allCount}
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
              <Table aria-label="open passes" size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Student Name</StripedTableCell>
                    <StripedTableCell>Checked In</StripedTableCell>
                  </StripedTableRow>
                </TableHead>
                <TableBody>
                  <TableRowNoResults data={_presentStudents} />
                  {_presentStudents.map((student, i) => (
                    <StripedTableRow key={i}>
                      <StripedTableCell>
                        <div className="emphasis">
                          {student.last_name}, {student.first_name}
                          {isEmpty(student.mi) === false && (
                            <> {student.mi}.</>
                          )}{" "}
                          ({student.grade})
                        </div>
                      </StripedTableCell>
                      <StripedTableCell>
                        {dayjs(student.dateCreated).format("MM/DD hh:mm a ")}
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {isSomethingFocused()}
      </Container>
    </>
  );
};

export default ActivityKiosk;
